<template>
  <div style="padding-bottom: 50px">
    <header>
      <div class="headerDiv" v-on:click="backHistory"  @click="">
        <van-icon name="arrow-left" size="18px" />
        <span>返回</span>
        <!--<img src="@/assets/img/back.png" alt=""><span>返回</span>-->
        <!--<p style="color: #FFFFFF">支付</p>-->
      </div>
    </header>
    <!--<header>-->
      <!--<div style="display: flex;align-items: center;padding: 0 10px">-->
        <!--<div class="location"><van-icon color="#FFFFFF" name="location-o" size="25"/> </div>-->
        <!--<div class="search" @click="toSearch">-->
          <!--<span></span>-->
          <!--<van-search-->
            <!--v-model="name"-->
            <!--shape="round"-->
            <!--background="#ff2500"-->
            <!--placeholder="请输入搜索关键词"-->
            <!--v-on:input="getWrite"/>-->
        <!--</div>-->
        <!--<div class="searchIcon">-->
          <!--<router-link to="/newShop"><van-icon color="#FFFFFF" size="25" name="shopping-cart-o" /></router-link>-->
        <!--</div>-->
      <!--</div>-->
    <!--</header>-->
    <div class="Carousel">
      <div style="width: 100%;">
        <van-swipe :autoplay="3000" :duration="100" type="card"  style="width:95%;margin: auto">
          <!--<van-swipe-item v-for="(image, index) in images" :key="index">-->
          <!--<img style="width: 100%;height: 100%" v-lazy="image" />-->
          <!--{{image}}-->
          <!--</van-swipe-item>-->
          <van-swipe-item v-for="(item,index) in images" :key="index">
            <router-link to="riceShop"><img src="@/assets/img/activtiyImg.jpg" class="swipeImg" style=""  /></router-link>
          </van-swipe-item>
        </van-swipe>
      </div >
      <!--<div class="classification">-->
      <!--<div v-for="(item,index) in categoryList" style="margin-bottom: 10px" @click="classification()">-->
      <!--<div class="classificationDiv">-->
      <!--<img :src="item.image" alt="">-->
      <!--</div>-->
      <!--<div class="classificationtext">{{item.title}}</div>-->
      <!--</div>-->

      <!--</div>-->
    </div>
    <!--<div class="scrollHour">-->
    <!--限时特价-->
    <!--</div>-->
    <!--<div style="width:100%;height: 150px;" class="scrollDiv">-->
    <!--<div class="scroll"  @click="toShopDetail">-->
    <!--<div class="scrollMessage" >-->
    <!--<div style="background: #ff2500;width: 100%;height:100px;">-->
    <!--</div>-->
    <!--<div class="shopMessage">-->
    <!--<span style="padding-top: 3px" class="shopMessageName" >产品名称</span>-->
    <!--<span style="padding-top: 3px" class="shopMessageName"><span>￥138</span><span class="messageLine">￥38</span></span>-->
    <!--</div>-->
    <!--</div>-->
    <!--</div>-->
    <!--</div>-->
    <div class="scrollHour">
      活动商品
    </div>
    <div class="shopList">
      <div class="shopDetail" v-for="(item,index) in list" @click="toShopDetail(item.id)" >
        <div class="shopDiv">
          <img :src="item.img" alt="">
        </div>
        <div class="shopMessage">
          <span class="shopMessageName" >{{item.title}}</span>
          <span class="shopMessagePrice"><span style="color: #ff2500">￥{{item.price }}</span>
            <!--<span class="shopMessageF">{{item.sales_volume}} 付款</span></span>-->
            <span class="shopMessageF"><van-icon color="" size="18" name="shopping-cart-o" /></span></span>
        </div>
      </div>
      <!--<div class="shopDetail">-->
      <!--<div class="shopDiv"></div>-->
      <!--<div class="shopMessage">-->
      <!--<span class="shopMessageName" >产品名称</span>-->
      <!--<span class="shopMessageName"><span>￥38</span><span class="shopMessageF">165 付款</span></span>-->
      <!--</div>-->
      <!--</div>-->



      <!--<div class="shopDiv"></div>-->
      <!--<div class="shopDiv"></div>-->
      <!--<div class="shopDiv"></div>-->
    </div>
    <div class="go">
      <img style="width: 60px"  @click="href()" src="@/assets/img/go2.png" alt="">
    </div>
    <van-tabbar route  active-color="#ff2500">
      <!--<van-tabbar-item replace to="/home" icon="wap-home-o">-->
      <!--<van-tabbar-item replace to="/home" icon="home-o">-->
      <!--商城-->
      <!--</van-tabbar-item>-->
      <!--<template #icon="props">-->
      <!--<img src="@/assets/img/go2.png" alt="">-->
      <!--</template>-->
      <van-tabbar-item replace to="/home" icon="home-o">
        商城
      </van-tabbar-item>
      <van-tabbar-item replace to="/homeClass" icon="apps-o">
        分类
      </van-tabbar-item>
      <van-tabbar-item replace to="/newShop" icon="wap-home-o">
        购物车
      </van-tabbar-item>

      <van-tabbar-item replace to="/myShop" icon="contact">
        我的
      </van-tabbar-item>
    </van-tabbar>
    <!--<van-tabbar v-model="active">-->
    <!--<van-tabbar-item badge="3">-->
    <!--<span>自定义</span>-->
    <!--<template #icon="props">-->
    <!--<img :src="props.active ? icon.active : icon.inactive" />-->
    <!--</template>-->
    <!--</van-tabbar-item>-->
    <!--<van-tabbar-item icon="search">标签</van-tabbar-item>-->
    <!--<van-tabbar-item icon="setting-o">标签</van-tabbar-item>-->
    <!--</van-tabbar>-->
  </div>
</template>

<script>
  import Vue from 'vue';
  import { Swipe, SwipeItem } from 'vant';

  Vue.use(Swipe);
  Vue.use(SwipeItem);
  //  import Vue from 'vue';
  import { Lazyload } from 'vant'
  Vue.use(Lazyload);
  export default {
    name: 'message',
    data () {
      return {
        msg: '',
        color:"#FFFFFF",
//        color:"#000000",
        bool:true,
        radio:'',
        images: [
//          'https://img.yzcdn.cn/vant/apple-1.jpg',
//          'https://img.yzcdn.cn/vant/apple-2.jpg',
//          'https://img.yzcdn.cn/vant/apple-3.jpg',
        ],
        list:[],
        categoryList:[]
      }
    },
    methods:{
      backHistory(){
        this.$router.go(-1)
      },
      clickIcon(event){
        console.log(event)
        this.bool=!this.bool
        console.log(this.bool)
//        if(bool){
//          this.color="FFFFFF"
//        }
//        this.color="#FFFFFF"
      },
      href(){
        window.location.href = 'https://m.shangshebao.com';
      },
      classification(){
        this.$router.push("/classification")
      },
      toSearch(){
        this.$router.push("/search")
      },
      toShopDetail(id){
        this.$router.push({
//            path:"/shopDetail",
          path:"/newShopDetail",
          query:{
            id:id
          }
        })
      },
      shopCarouselImger(){
        this.$api.shopCarouselImg()
          .then(res=>{
            this.images=res.data
            console.log(res)
          })
      },
      shopLister(){
        this.$api.selectActivityGoodsList()
          .then(res=>{
            this.list=res.data
            console.log(this.list)
          })
      },
      shopclassificationer(){
        this.$api.shopclassification()
          .then(res=>{
            this.categoryList=res.data
          })
      },
      selectCoupon(){
        this.$api.selectCoupon()
          .then(res=>{
            console.log(res)
          })
      }
    },
    mounted(){
      this.shopCarouselImger()
      this.shopLister()
      this.shopclassificationer()
      this.selectCoupon()
    }
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style  scoped="">
  *{
    /*overflow-x:hidden;*/
  }
  header{
    width: 100%;
    height: 45px;
    background:#fff ;
    position: fixed;
    z-index: 200;
    top: 0;
    display: flex;
    align-items: center;
  }
  header img{
    width: 20px;
    height: 20px;
  }
  .headerDiv{
    display: flex;
    align-items: center;
    /*line-height: 60px;*/
  }
  .headerDiv p{
    margin: auto;
    font-size: 18px;
  }
  .swipeImg{
    width: 100%;
    /*height: 100%;*/
    border-radius:1rem;
  }
  .location{
    /*width: 10%;*/
    /* margin: auto; */
    display: flex;
    justify-content: center;
  }
  /*header{*/
    /*width: 100%;*/
    /*!*height: 70px;*!*/
    /*background:#ff2500 ;*/
    /*position: fixed;*/
    /*z-index: 200;*/
    /*top: 0;*/
  /*}*/
  .searchDiv{
    width: 100%;
    /*display: flex;*/
    background-color: #6e9bcf;
    color: #fff;
    align-items: center;
    position: fixed;
    top: 0;
    left: 0;
    z-index: 2;
  }
  .search{
    /*width: 90%;*/
    flex: 1;
  }
  .searchIcon{
    /*width: 10%;*/
    display: flex;
    align-items: center;
    background-color: #ff2500;
    color: #ffffff;
  }
  /deep/ .van-swipe{
    width: 100%;
    height: 100%;
  }
  .scroll{
    height: 100%;
    width: 200%;
    white-space:nowrap;
    overflow-y:hidden;
    overflow-x:scroll;
    display:flex;
    /*display: flex;*/

    /*::-webkit-scrollbar可以设置滚动条样式，display：none，去掉滚动条*/
  }
  .scrollDiv{
    overflow-x:scroll;
  }
  ::-webkit-scrollbar{
    display: none;
  }
  .Carousel{
    /*background: #E4E4E4;*/
    background: #f9f6f6;
    margin-top: 45px;
    padding-top: 10px;
    padding-bottom: 1rem;
  }
  .classification{
    width: 100%;
    display: flex;
    /*justify-content: space-around;*/
    justify-content: center;
    flex-wrap:wrap;
    margin-top: 1.5rem;
    font-size: 15px;
  }
  .classificationDiv{
    width: 50px;
    height: 50px;
    background: #6e9bcf;
    border-radius: 100%;
    margin: 5px 1rem;
  }
  .classificationDiv img{
    width: 100%;
    height: 100%;
    border-radius: 100%;
  }
  .classificationtext{
    text-align: center;
  }
  .scrollHour{
    /*height: 20px;*/
    border-left: solid 4px;
    line-height: 2rem;
    height: 2rem;
    padding-left: 1rem;
  }
  /*推荐商品*/
  .shopList{
    display:flex ;
    flex-wrap:wrap;
    background: #e4e4e4;
    padding-bottom: 20px;
    /*justify-content: center;*/
  }
  .shopDiv{
    width: 100%;
    /*height: 120px;*/
    /*background: #6e9bcf;*/
    border-radius: 1rem;
    /*margin-left: 1px;*/
    /*margin: 10px;*/
  }
  .shopDiv img{
    width: 100%;
    /*height: 100%;*/
  }
  .shopDetail{
    /*width: 40%;*/
    /*margin: 8px 5%;*/
    /*color: #898888;*/

    width: 40%;
    margin: 8px 0 1% 4%;
    color: #898888;
    background: #ffffff;
    padding: 3%;
    margin-left: 10px;
  }
  .shopMessageName{
    display: block;
    color: #898888;
  }
  .shopMessagePrice{
    display: flex;
    justify-content: space-between;
    align-items: center;
  }
  .shopMessage span{
    padding-top: 2px;
  }
  .shopMessageName:first-child{
    /*font-size: 18px;*/
  }
  .shopMessageName:last-child{
    /*font-size: 12px;*/
  }
  .shopMessageF{
    font-size: 12px;
    margin-left: 10px;
  }
  .shopMessage{
    /*text-align: center;*/
  }
  .messageLine{
    text-decoration: line-through;
    margin-left: 10px;
  }
  .shopMessage{
    font-size: 12px;
  }
  .scrollMessage{
    width: 100px ;
    height: 100%;
    margin-left: 10px;
  }
  .go{
    position: fixed;
    top: 70%;
    right: 10px;
    border: solid 2px #e4e4e4;
    border-radius: 100%;
    /*background: #ffffff;*/
  }
  .go img{
    width: 60px;
  }
</style>



// WEBPACK FOOTER //
// src/components/shop/activity.vue